import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask'
import { CoordinatorService } from '../../../core/services/coordinator/coordinator.service'
import { EditCoordinatorModel } from '../../../core/models/coordinator.model'

@Component({
  selector: 'coordinator-edit',
  imports: [
    MatButton,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatIcon,
    MatFormField,
    MatInput,
    MatLabel,
    NgxMaskDirective,
  ],
  templateUrl: './coordinator-edit.component.html',
  styleUrl: './coordinator-edit.component.scss',
  providers: [CoordinatorService, provideNgxMask({ dropSpecialCharacters: false })],
  standalone: true,
})
export class CoordinatorEditComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private coordenadorService: CoordinatorService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<CoordinatorEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.itemEdit = data.item ?? data
  }

  @Output() responseEdit = new EventEmitter()

  itemEdit: any = {}
  form: FormGroup = new FormGroup({})
  loading = false

  ngOnInit(): void {
    this.createForm()
  }

  updateItem() {
    this.loading = true
    const model = this.createModel()
    this.coordenadorService.editCoordenador(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseEdit.emit(true)
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  close() {
    this.dialogRef.close()
  }

  createModel(): EditCoordinatorModel {
    return {
      id: this.itemEdit.id,
      nome: this.form.controls['nome'].value,
      contato: this.form.controls['contato'].value,
    }
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      nome: [this.itemEdit.nome, [Validators.required]],
      contato: [this.itemEdit.contato, [Validators.required]],
    })
  }
}
